// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2ValB","itemLink":"index_itemLink_1SNlJ","itemPic":"index_itemPic_pJYrw","itemIcon":"index_itemIcon_1yMiz","avatar":"index_avatar_28V-A"};